import { notifications } from '@/store/ui';
import css from './NotificationStack.module.css';

export function NotificationStack() {
  return (
    <div class={css.stack} role="status" aria-live="polite">
      {notifications.value.map((n) => (
        <div key={n.id} class={css.toast}>
          {n.message}
        </div>
      ))}
    </div>
  );
}
